import create from './create'
import update from './update'
import deleteEvent from './delete'
import addAssets from './addAssets'
import deleteAsset from './deleteAsset'

export default { create, update, deleteEvent, addAssets, deleteAsset }
